import { CourseByIdDTO } from "../../api/Courses/GetCourseById";
import { Disclosure, Transition } from "@headlessui/react";
import AnchorDownIcon from "../Icons/AnchorDownIcon";
// import VideoIcon from '../Icons/VideoIcon';
import LockIcon from "../Icons/LockIcon";

const CourseContent = ({ courses }: { courses?: CourseByIdDTO }) => {
  return (
    <div className="xl:max-w-[800px] w-full">
      <div className="pt-8 w-full">
        <h1 className="font-bold sm:text-2xl text-lg tracking-[0.02em] sm:mb-6 mb-5">
          Course Content
        </h1>
        <div className="space-y-5">
          {courses?.chapters?.map((chapter, index) => (
            <div
              key={index}
              className="px-5 sm:pt-5 sm:pb-6 py-4 border border-black/20 shadow rounded-2xl"
            >
              <Disclosure>
                {({ open }) => (
                  <>
                    <Disclosure.Button
                      className={`border-b-[1.6px] border-black/20 pb-3 items-center gap-4 flex w-full justify-between font-semibold sm:text-0.5xl duration-300 transition-all ease-in-out text-left ${
                        open ? "text-primary" : "text-burntBlack"
                      }`}
                    >
                      <span>
                        Module {index + 1} -{" "}
                        {chapter.name || "Description not available"}
                      </span>
                      <div className="sm:size-10 sm:min-w-10 min-w-[30px] min-h-[30px] size-[30px] bg-primary bg-opacity-5 border border-primary border-opacity-[0.07] rounded-full flex justify-center items-center">
                        <AnchorDownIcon
                          className={`!text-inherit transition duration-300 ease-in-out ${
                            open ? "" : "rotate-180"
                          }`}
                        />
                      </div>
                    </Disclosure.Button>
                    <p
                      className={`text-lightGray sm:text-base text-sm font-medium sm:mt-5 mt-4 text-justify ${
                        open ? "hidden" : ""
                      }`}
                    >
                      {chapter.description}
                    </p>
                    {chapter.video && (
                      <div className={`${open ? "" : "hidden"} mt-5`}>
                        <iframe
                          src={`https://player.vdocipher.com/v2/?otp=${chapter?.video.otp}&playbackInfo=${chapter?.video.playbackInfo}`}
                          className="w-full sm:h-[450px] h-[300px] object-cover border-0"
                          allow="encrypted-media"
                          allowFullScreen
                        ></iframe>
                      </div>
                    )}
                    <Transition
                      show={open}
                      enter="transition duration-300 ease-out"
                      enterFrom="transform scale-95 opacity-0"
                      enterTo="transform scale-100 opacity-100"
                      leave="transition duration-150 ease-out"
                      leaveFrom="transform scale-100 opacity-100"
                      leaveTo="transform scale-95 opacity-0"
                    >
                      <Disclosure.Panel className="pt-5 sm:space-y-5 space-y-4">
                        {/* {chapter.lectures.slice(0, 2).map((lecture) => (
                          <div key={lecture.id} className='flex justify-between items-center'>
                            <div className='flex gap-2 items-center'>
                              <VideoIcon className={`sm:size-auto size-5`} isActive={true} />
                              <h1 className='text-primary font-medium -tracking-[0.02em] sm:text-xl text-sm'>{lecture.title}</h1>
                            </div>
                            <span className='sm:text-lg text-sm font-medium text-primary -tracking-[0.02em]'>Video Length</span>
                          </div>
                        ))} */}
                        {chapter?.lectures?.map((lecture) => (
                          <div
                            key={lecture.id}
                            className="flex justify-between items-center"
                          >
                            <div className="flex gap-2 items-center">
                              <LockIcon className={`sm:size-auto size-5`} />
                              <h1 className="text-lightGray font-medium -tracking-[0.02em] sm:text-xl text-sm">
                                {lecture.title}
                              </h1>
                            </div>
                          </div>
                        ))}
                      </Disclosure.Panel>
                    </Transition>
                  </>
                )}
              </Disclosure>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CourseContent;
